import React, { useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DossierBusinessInfo } from './DossierBusinessInfo';
import { DossierLandInventory } from './DossierLandInventory';
import { DossierLivestock } from './DossierLivestock';
import { DossierBuildingsMeans } from './DossierBuildingsMeans';
import './DossierPanel.css';

export function DossierPanel({ 
  dossier,
  className = '',
  reportType = 'plants',
}) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem('dossier-panel-expanded');
    return saved ? JSON.parse(saved) : true;
  });

  // Save collapse state to localStorage and update body class
  useEffect(() => {
    localStorage.setItem('dossier-panel-expanded', JSON.stringify(isExpanded));
    if (isExpanded) {
      document.body.classList.remove('dossier-panel-collapsed');
    } else {
      document.body.classList.add('dossier-panel-collapsed');
    }
    return () => {
      document.body.classList.remove('dossier-panel-collapsed');
    };
  }, [isExpanded]);

  if (!dossier) {
    return null;
  }

  const activeSectionLabel = t('reports.workspace.dossier.title');

  return (
    <div className={`dossier-panel ${isExpanded ? 'dossier-panel--expanded' : 'dossier-panel--collapsed'} dossier-panel--dossier ${className}`}>
      {/* Panel Header */}
      <div className={`dossier-panel__header ${isExpanded ? '' : 'dossier-panel__header--collapsed'}`}>
        {isExpanded ? (
          <>
            <h3 className="dossier-panel__title">{activeSectionLabel}</h3>
            <button
              className="dossier-panel__collapse-btn"
              onClick={() => setIsExpanded(false)}
              aria-label={t('reports.workspace.dossier.collapseAria')}
            >
              <ChevronRight size={20} />
            </button>
          </>
        ) : (
          <button
            className="dossier-panel__collapse-btn dossier-panel__collapse-btn--collapsed"
            onClick={() => setIsExpanded(true)}
            aria-label={t('reports.workspace.dossier.expandAria')}
          >
            <ChevronLeft size={20} />
          </button>
        )}
      </div>

      {/* Panel Content */}
      {isExpanded && (
        <div className="dossier-panel__content">
          <div className="dossier-panel__section">
            <DossierBusinessInfo dossier={dossier} />

            {dossier.landInventory && dossier.landInventory.length > 0 && (
              <DossierLandInventory landInventory={dossier.landInventory} />
            )}

            {(reportType === 'animals' || reportType === 'livestock') && dossier.livestock && dossier.livestock.length > 0 && (
              <DossierLivestock livestock={dossier.livestock} />
            )}

            {(dossier.buildings || dossier.means) && (
              <DossierBuildingsMeans
                buildings={dossier.buildings}
                means={dossier.means}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

